export default __webpack_public_path__ + "static/media/5B.7da3f78c.png";